<template>
  <div>
    <b-card class="mb-2 shadow bg-light">
      <b-card-title title-tag="h6">Indemnités</b-card-title>
      <template v-if="$props.arrangement == 0">
        <b-button
          v-if="$store.getters.isAdmin"
          @click="ajouter"
          size="sm"
          class="mb-2"
          title="Nouvelle indemnité"
          ><b-icon-plus-circle-fill></b-icon-plus-circle-fill
        ></b-button>
        <b-button
          title="Mettre à jour"
          v-if="$store.getters.isAdmin"
          @click="updateIndemnities()"
          size="sm"
          class="ml-2 mb-2"
          ><b-icon-arrow-repeat></b-icon-arrow-repeat
        ></b-button>
      </template>
      <template v-else>
        <p>
          <i
            >Un arrangement est en cours pour ce mandat. Les indemnités sont
            figées</i
          >
        </p>
      </template>

      <b-table
        v-if="indemnities.length > 0"
        id="indemnitiesTable"
        responsive
        striped
        small
        hover
        :fields="indemnitiesFields"
        :items="indemnities"
      >
        <template v-slot:cell(montant)="data"
          >{{ twoDigits(data.item.montant) }} €</template
        >
        <template v-slot:cell(actions)="data">
          <div class="text-center">
            <template v-for="(entry, i) in actions">
              <b-button
                v-if="
                  entry.condition == undefined || entry.condition(data.item)
                "
                :title="entry.label"
                size="sm"
                :icon="entry.icon ? true : false"
                :class="entry.icon ? 'btn-xs mr-2' : 'mr-2'"
                :key="i"
                :variant="entry.variant ? entry.variant : ''"
                @click="entry.event(data.item)"
              >
                <b-icon v-if="entry.icon" :icon="entry.icon"></b-icon>
                <span v-else>{{ entry.label }}</span>
              </b-button>
            </template>
          </div>
        </template>
        <template v-slot:bottom-row>
          <td />
          <td />
          <td>
            <strong>Total</strong>
          </td>
          <td>
            <strong>
              <span class="float-right"
                >{{
                  indemnities
                    .filter((x) => x.paye == "non")
                    .reduce((a, b) => a + parseFloat(b.montant), 0)
                    .toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                }}
                €</span
              >
            </strong>
          </td>
          <td />
        </template>
      </b-table>
      <b-card-body v-else>
        <b-alert show>Pas d'indemnités</b-alert>
      </b-card-body>
    </b-card>
    <b-modal id="modal-modifier" title="Modifier une indemnité" hide-footer>
      <Indemnity
        @change="load(true)"
        @close="$bvModal.hide('modal-modifier')"
        :indemnity_id="indemnity_id"
        :warrant_id="warrant_id"
      ></Indemnity>
    </b-modal>
    <b-modal
      id="modal-ajouter"
      title="Ajouter une nouvelle indemnité"
      hide-footer
    >
      <Indemnity
        @change="load(true)"
        @close="$bvModal.hide('modal-ajouter')"
        indemnity_id="new"
        :warrant_id="warrant_id"
      ></Indemnity>
    </b-modal>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
import Indemnity from "@/components/Indemnity.vue";
export default {
  name: "warrant-indemnities",
  props: ["id", "arrangement"],
  components: {
    Indemnity,
  },
  data() {
    return {
      loaded: false,
      indemnities: [],
      indemnity_id: null,
      warrant_id: null,
      actions: [
        {
          label: "supprimer",
          event: this.supprimer,
          icon: "x-circle-fill",
          variant: "danger",
          condition: () => this.$store.getters.isSuperAdmin,
        },
        {
          label: "modifier",
          event: this.modifier,
          icon: "pencil-square",
          variant: "success",
        },
      ],
      indemnitiesFields: [
        {
          key: "type",
          label: "Type",
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case "frais dossier":
                return "Frais de dossier";
              case "interet":
                return "Intérêt";
              case "clause penale":
                return "Clause pénale";
              case "divers":
                return "Divers";
              case "frais de mise en demeure":
                return "Frais de mise en demeure";
              case "frais de recouvrement":
                return "Frais de recouvrement";
              case "frais de deplacement":
                return "Frais de déplacement";
              case "valeur residuelle":
                return "Valeur résiduelle";
              default:
                return "Indemnité";
            }
          },
        },

        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "paye",
          label: "Payé",
          sortable: true,
        },
        {
          key: "montant",
          label: "Montant",
          sortable: true,
          class: "text-right",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    supprimer(row) {
      warrants
        .delete_indemnity({
          warrant_id: row.mandatID,
          indemnity_id: row.ID,
        })
        .then((response) => {
          if (response.data.success) {
            this.load(true);
          }
        });
    },
    modifier(row) {
      this.warrant_id = row.mandatID;
      this.indemnity_id = row.ID;
      this.$bvModal.show("modal-modifier");
    },
    ajouter() {
      this.warrant_id = this.id;
      this.$bvModal.show("modal-ajouter");
    },
    load(emit = false) {
      warrants.indemnities(this.$props.id).then((response) => {
        this.indemnities = response.data;
        this.loaded = true;
        if (emit) {
          this.$emit("change");
        }
      });
    },
    updateIndemnities() {
      warrants.updateIndemnities(this.$props.id).then(() => {
        this.load();
        this.$emit("change");
      });
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>